import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { attachmentsSliceKey } from "./+store/slices/attachments/attachments-slice.config";
import { attachmentsReducer } from "./+store/slices/attachments/attachments.slice";
import { currentMessageSliceKey } from "./+store/slices/current-message/current-message-slice.config";
import { currentMessageReducer } from "./+store/slices/current-message/current-message.slice";

@NgModule({
    imports: [StoreModule.forFeature(attachmentsSliceKey, attachmentsReducer), StoreModule.forFeature(currentMessageSliceKey, currentMessageReducer)],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedApiKno2fyMainModule {}
